import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Channel } from '../models/Channel.Model';
import { Route } from '../models/Route.Model';
import { Unit } from '../models/Unit.Model';
import { GenericService } from '../services/GenericServices';

export type TypeMode = 'default' | 'channel' | 'route' | 'organization' | 'region';

@Component({
  selector: 'aph-custom-select',
  templateUrl: './aph-custom-select.component.html',
  styleUrls: ['./aph-custom-select.component.scss']
})
export class AphCustomSelectComponent implements OnInit, OnChanges {

  // Configuración de datos
  @Input() items: any[] = [];
  @Input() type: TypeMode = 'default'; 
  @Input() filter: string = '';
  @Input() org: string = '';
  @Input() userId: string = '';
  @Input() ceveId: string = '';
  @Input() bindLabel: string = 'text';
  @Input() bindValue: string = 'id';
  @Input() placeholder: string = 'Seleccione una opción';
  
  // Opción por defecto (ej. "Todos")
  @Input() disabled: boolean = false;
  @Input() showDefaultOption: boolean = false;
  @Input() defaultLabel: string = 'Todos';
  @Input() selectedValue: any = null;
  @Input() defaultValue: any = 0;

  @Input() value: any;
  @Output() returnValue = new EventEmitter<any>();
  // Eventos de salida
  @Output() onSelectionChange = new EventEmitter<void>();
  @Output() onSelectionChangeWhitValue = new EventEmitter<any>();
  @Output() onInputBlur = new EventEmitter<void>();

  constructor(
    private apiService: GenericService,
    private cd: ChangeDetectorRef
  ) {}  

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    // Sincronizar el valor seleccionado desde el padre
    if (changes.selectedValue) {
      this.value = changes.selectedValue.currentValue;
    }

    // Recargar items si cambian los filtros o el tipo
    if (changes.items || changes.filter || changes.ceveId || changes.org || changes.userId || changes.type) {
      if (this.type === 'default' || !this.type) {
        this.applyDefaultOption();
      } else {
        await this.sendItems();
      }
    }
    this.cd.detectChanges();
  }

  async ngOnInit(): Promise<void> {
    // Si es default, los items ya vienen por Input, solo aplicamos la opción extra
    if (this.type === 'default' || !this.type) {
      this.applyDefaultOption();
    } else {
      await this.sendItems();
    }
  }

  private applyDefaultOption(): void {
    if (this.showDefaultOption && this.items) {
      const exists = this.items.some(item => item[this.bindValue] == this.defaultValue);
      if (!exists) {
        const defaultOpt = { 
          [this.bindLabel]: this.defaultLabel, 
          [this.bindValue]: this.defaultValue 
        };
        this.items = [defaultOpt, ...this.items];
      }
    }
    this.cd.detectChanges();
  }

  async sendItems(): Promise<void> {
    // Guard: Si es default, no consultamos API ni sobreescribimos items
    if (this.type === 'default' || !this.type) return;

    let data: any[] = [];
    
    try {
      switch (this.type) {
        case 'channel':
          this.bindLabel = 'ChannelName';
          this.bindValue = 'ChannelCode';
          data = await this.apiService.getRequest(this.filter.length > 0 ? `route/channel/${this.filter}` : `channel`, {}, 0).toPromise() as Channel[];
          break;  
        case 'route':
          this.bindLabel = 'RouteName';
          this.bindValue = 'RouteId';
          data = await this.apiService.getRequest(`route/byChannel/${this.ceveId}/0`, {}, 0).toPromise() as Route[];
          if(this.filter.length > 0) {
            data = data.filter(s => s.ChannelCode == this.filter.toString());
          }
          break;  
        case 'organization':
          this.bindLabel = 'UnitDescription';
          this.bindValue = 'UnitId';
          data = await this.apiService.getRequest(`userprofile/organizationbyuser/${this.org}/${this.userId}`, {}, 0).toPromise() as Unit[];
          break;  
        case 'region':
          this.bindLabel = 'UnitDescription';
          this.bindValue = 'UnitId';
          const regionFilter = this.filter.length > 0 ? this.filter : '0';
          data = await this.apiService.getRequest(`userprofile/regions/${this.org}/${this.userId}/${regionFilter}`, {}, 0).toPromise() as Unit[];
          break;  
      }

      if (this.showDefaultOption) {
        const defaultOpt = { [this.bindLabel]: this.defaultLabel, [this.bindValue]: this.defaultValue };
        this.items = [defaultOpt, ...data];
      } else {
        this.items = data || [];
      }
    } catch (error) {
      console.error("Error cargando items:", error);
      this.items = [];
    }
    
    this.cd.detectChanges();
  }

  public doSelect(event: any): void {
    this.value = event;
    this.returnValue.emit(event);
    this.onSelectionChange.emit();
    this.onSelectionChangeWhitValue.emit(event);
  }

  public doBlur(): void {
    this.onInputBlur.emit();
  }
}